module.exports = __webpack_public_path__ + "static/media/logo.eeabe02d.png";